import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DataService } from 'app/auth/services/data.service';
import { EncryptionService } from 'app/auth/services/encryption.service';
import { firstValueFrom } from 'rxjs';

export const roleGuard: CanActivateFn = async (route, state) => {
  const dataServ = inject(DataService);
  const encService = inject(EncryptionService);
  const router = inject(Router);
  try {
    const currentUser = await firstValueFrom(dataServ.currentUser);
    const roleOfUser = Number(encService.decrypt(currentUser.role)); // Ensure `decrypt` returns the correct role type

    const allowedRoles = route.data?.['roles'] as Array<any>;

    if (allowedRoles?.includes(roleOfUser)) {
      return true;
    }

    router.navigate(['/unauthorized']);
    return false;
  } catch (error) {
    console.error('Role Guard Error:', error);
    router.navigate(['/unauthorized']);
    return false;
  }
};
